import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export interface LoaderProps {
  size?: number;
}

const Loader: React.FC<LoaderProps> = ({ size }) => {
  return <CircularProgress size={size} />;
};

export default Loader;
